import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5497872c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ion-text-center" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Antal slutspelsmatcher", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "(första omgången)", -1))

import ButtonsRow from '@/components/ButtonsRow.vue'
import { IonContent, IonFooter, IonItem, IonLabel, IonSegment, IonSegmentButton } from '@ionic/vue'
import { reactive } from 'vue'
import Round from '../components/Round.vue'

type RoundType = 'semis' | 'quarters' | 'eights' | 'sixteens' | 'thirtytwos' | 'sixtyfours' | 'hundredtwentyeights'

const MIN_VALUE = 4
const MAX_VALUE = 128


export default /*#__PURE__*/_defineComponent({
  __name: 'Playoffs',
  props: {
    qualifiers: {},
    direct: {}
  },
  emits: ['set-qualifiers', 'set-direct'],
  setup(__props: any, { emit: __emit }) {

const rounds = [
	'semis',
	'quarters',
	'eights',
	'sixteens',
	'thirtytwos',
	'sixtyfours',
	'hundredtwentyeights'
] as RoundType[]

const { qualifiers, direct } = __props
const emit = __emit

const state = reactive({
	qualifiers,
	direct,
	min: MIN_VALUE,
	max: MAX_VALUE,

	semis: 0,
	quarters: 0,
	eights: 0,
	sixteens: 0,
	thirtytwos: 0,
	sixtyfours: 0,
	hundredtwentyeights: 0,
	tables: 0
})

const setDirect = (direct: number) => {
	state.direct = direct
	show()
	emit('set-direct', direct)
}

const setQualifiers = (qualifiers: number) => {
	state.qualifiers = qualifiers
	show()
	emit('set-qualifiers', qualifiers)
}

const decrease = (value: number = 1) => {
	setQualifiers(Math.max(state.qualifiers - value, MIN_VALUE))
}

const increase = (value: number = 1) => {
	setQualifiers(Math.min(state.qualifiers + value, MAX_VALUE))
}

const show = () => {
	const NUM = state.qualifiers + state.direct
	// Reset rounds
	state.semis =
		state.quarters =
		state.eights =
		state.sixteens =
		state.thirtytwos =
		state.sixtyfours =
		state.hundredtwentyeights =
			0
	// Binary of number,
	// e.g. 26 => 11010
	// e.g. 34 => 100010
	const bin = (+NUM).toString(2)

	// Modulo of the highest power of 2 in NUM
	// e.g. 26 = 1 * 2^4 + 10 => 10
	// e.g. 34 = 1 * 2^5 + 2  => 2
	const rest = parseInt(bin.substring(1), 2)

	// 2nd highest power of 2 in NUM
	// e.g. 11010  => _1___  => 2^3 = 8
	// e.g. 100010 => _1____ => 2^4 = 16
	const bin2nd = Math.pow(2, bin.length - 2)

	// Check if 2nd highest power of 2 is in bin (which is the "turning point")
	// e.g. 26 => 11010  => _1___  => true
	// e.g. 34 => 100010 => _0____ => false
	const bool = +bin.charAt(1)

	// Sum tables
	// Max value of rest or 2nd highest power
	// e.g. 26 => Math.max(10, 8)
	// e.g. 34 => Math.max(2, 16)
	state.tables = Math.max(rest, bin2nd)

	// Round counts
	// if (2 < NUM && NUM <= 5) {
	// 	state.semis = !bool && NUM >= 4 ? 2 - rest : rest
	// }
	// if (4 < NUM && NUM <= 11) {
	// 	state.quarters = !bool && NUM >= 8 ? 4 - rest : rest
	// }
	// if (8 < NUM && NUM <= 23) {
	// 	state.eights = !bool && NUM >= 16 ? 8 - rest : rest
	// }
	// if (16 < NUM && NUM <= 47) {
	// 	state.sixteens = !bool && NUM >= 32 ? 16 - rest : rest
	// }
	// if (32 < NUM && NUM <= 95) {
	// 	state.thirtytwos = !bool && NUM >= 64 ? 32 - rest : rest
	// }
	// if (64 < NUM && NUM <= 190) {
	// 	state.sixtyfours = !bool && NUM >= 128 ? 64 - rest : rest
	// }

	// Sum up tables per round type
	rounds.forEach((round: string, i: number) => {
		const min = Math.pow(2, i + 1)
		const max = min * 3 - 1
		if (min < NUM && NUM <= max) {
			state[round as RoundType] = !bool && NUM >= min * 2 ? min - rest : rest
		}
	})

	// console.log(`binary: ${bin}, rest: ${rest}`)
}
show()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(IonContent), null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _hoisted_3,
          _createElementVNode("h3", null, [
            _createElementVNode("strong", null, _toDisplayString(state.tables) + " st", 1)
          ])
        ]),
        _createVNode(Round, {
          value: state.semis,
          color: 'primary',
          title: 'Semifinaler',
          highlight: true
        }, null, 8, ["value"]),
        _createVNode(Round, {
          value: state.quarters,
          color: 'secondary',
          highlight: false,
          title: 'Kvartar'
        }, null, 8, ["value"]),
        _createVNode(Round, {
          value: state.eights,
          color: 'tertiary',
          title: '1/8-delar',
          highlight: true
        }, null, 8, ["value"]),
        _createVNode(Round, {
          value: state.sixteens,
          color: 'warning',
          highlight: false,
          title: '1/16-delar'
        }, null, 8, ["value"]),
        _createVNode(Round, {
          value: state.thirtytwos,
          color: 'danger',
          title: '1/32-delar',
          highlight: true
        }, null, 8, ["value"]),
        _createVNode(Round, {
          value: state.sixtyfours,
          color: 'dark',
          title: '1/64-delar',
          highlight: true
        }, null, 8, ["value"]),
        _createVNode(Round, {
          value: state.hundredtwentyeights,
          color: 'medium',
          title: '1/128-delar',
          highlight: true
        }, null, 8, ["value"])
      ]),
      _: 1
    }),
    _createVNode(_unref(IonFooter), null, {
      default: _withCtx(() => [
        _createVNode(_unref(IonItem), { lines: "none" }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonLabel), null, {
              default: _withCtx(() => [
                _createTextVNode("Antal direktkvalificerade")
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_unref(IonSegment), {
          class: "mb",
          color: "tertiary",
          value: state.direct,
          onIonChange: _cache[0] || (_cache[0] = ($event: any) => (setDirect(+$event.target.value)))
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonSegmentButton), { value: 0 }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonLabel), null, {
                  default: _withCtx(() => [
                    _createTextVNode("0")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_unref(IonSegmentButton), { value: 2 }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonLabel), null, {
                  default: _withCtx(() => [
                    _createTextVNode("2")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_unref(IonSegmentButton), { value: 4 }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonLabel), null, {
                  default: _withCtx(() => [
                    _createTextVNode("4")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_unref(IonSegmentButton), { value: 8 }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonLabel), null, {
                  default: _withCtx(() => [
                    _createTextVNode("8")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_unref(IonSegmentButton), { value: 16 }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonLabel), null, {
                  default: _withCtx(() => [
                    _createTextVNode("16")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value"]),
        _createVNode(_unref(IonItem), { lines: "none" }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonLabel), null, {
              default: _withCtx(() => [
                _createTextVNode("Antal kvalificerade")
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(ButtonsRow, {
          value: state.qualifiers,
          min: state.min,
          max: state.max,
          onValChange: setQualifiers,
          onIncrease: increase,
          onDecrease: decrease
        }, null, 8, ["value", "min", "max"])
      ]),
      _: 1
    })
  ], 64))
}
}

})